"use strict";

var _registerCSSInterfaceWithDefaultTheme = _interopRequireDefault(require("./utils/registerCSSInterfaceWithDefaultTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

(0, _registerCSSInterfaceWithDefaultTheme["default"])();


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-dates/lib/initialize.js
 ** module id = 1245
 ** module chunks = 0
 **/